<template>
  <div id="app">
    <navbar></navbar>
    <flop @showphotos="showPhotos" :price="price"></flop>
    <stats id="stats"></stats>
    <about id="about"></about>
    <images id="photos" :images="images" @showphotos="showPhotos"></images>
    <features id="highlight"></features>
    <layouts id="layout"></layouts>
    <maps></maps>
    <contact id="contact" class="mt-5" :price="price"></contact>
    <footerr id="footer"></footerr>
    <photos v-if="photos" :images="images" @showphotos="showPhotos"></photos>
  </div>
</template>

<script>
import flop from "./sections/flop.vue";
import stats from "./sections/stats.vue";
import images from "./sections/images.vue";
import about from "./sections/about.vue";
import maps from "./sections/maps.vue";
import layouts from "./sections/layouts.vue";
import features from "./sections/features.vue";
import navbar from "./sections/menu.vue";
import photos from "./sections/photos.vue";
import contact from "./sections/contact.vue";
import footer from "./sections/footer.vue";

export default {
  mounted() {
    $(document).keyup((event) => {
      if (event.which === 27) {
        this.photos = true;
        this.showPhotos();
      }
    });
  },
  name: "App",
  data() {
    return {
      photos: false,
      price: "655,000",
      images: [
        "https://22064sale.com/images/home/outside-01.png",
        "https://22064sale.com/images/home/outside-02.png",
        "https://22064sale.com/images/home/outside-04.png",
        "https://22064sale.com/images/home/livingroom-01.png",
        "https://22064sale.com/images/home/livingroom-02.png",
        "https://22064sale.com/images/home/livingroom-03.png",
        "https://22064sale.com/images/home/kitchen-01.png",
        "https://22064sale.com/images/home/kitchen-02.png",
        "https://22064sale.com/images/home/kitchen-03.png",
        "https://22064sale.com/images/home/pantry-01.png",
        "https://22064sale.com/images/home/dinning-01.png",
        "https://22064sale.com/images/home/dinning-02.png",
        "https://22064sale.com/images/home/mudroom-01.png",
        "https://22064sale.com/images/home/mudroom-02.png",
        "https://22064sale.com/images/home/bathroom-downstairs-01.png",
        "https://22064sale.com/images/home/familyroom-01.png",
        "https://22064sale.com/images/home/entryway-01.png",
        "https://22064sale.com/images/home/entryway-02.png",
        "https://22064sale.com/images/home/upstairs-01.png",
        "https://22064sale.com/images/home/loft-01.png",
        "https://22064sale.com/images/home/loft-02.png",
        "https://22064sale.com/images/home/loft-03.png",
        "https://22064sale.com/images/home/bathroom-upstairs-01.png",
        "https://22064sale.com/images/home/master-01.png",
        "https://22064sale.com/images/home/master-bathroom-01.png",
        "https://22064sale.com/images/home/basement-05.jpg",
        "https://22064sale.com/images/home/basement-04.jpg",
        "https://22064sale.com/images/home/basement-03.jpg",
        "https://22064sale.com/images/home/basement-02.jpg",
        "https://22064sale.com/images/home/basement-01.jpg",
        "https://22064sale.com/images/home/outside-03.png",
        "https://22064sale.com/images/home/outside-05.png",
        "https://22064sale.com/images/home/outside-06.jpg",
        "https://22064sale.com/images/home/outside-07.jpg",
        "https://22064sale.com/images/home/outside-08.jpg",
      ],
    };
  },
  components: {
    flop,
    about,
    stats,
    images,
    maps,
    layouts,
    navbar,
    features,
    photos,
    contact,
    footerr: footer,
  },
  methods: {
    showPhotos(payload) {
      this.photos = !this.photos;

      if (this.photos) {
        $("body").addClass("overflow-hidden");
      } else {
        $("body").removeClass("overflow-hidden");
      }

      if (this.photos && typeof payload == "object") {
        console.log(payload.index);
        setTimeout(() => {
          $("#photos-takeover").animate(
            {
              scrollTop: $("#photo-" + payload.index).position().top - 24,
            },
            450
          );
        }, 100);
      }
    },
  },
};
</script>
